import { useEffect, useState } from 'react';

function format(ms: number): string {
  const totalMinutes = Math.floor(ms / 60000);
  const hours = Math.floor(totalMinutes / 60);
  const minutes = totalMinutes % 60;
  if (hours > 0) return `${hours}h ${minutes}m`;
  return `${minutes}m`;
}

export function useElapsedTime(startIso: string | null): string {
  const [elapsed, setElapsed] = useState('');

  useEffect(() => {
    if (!startIso) { setElapsed(''); return; }
    const tick = () => {
      const ms = Date.now() - new Date(startIso).getTime();
      setElapsed(ms > 0 ? format(ms) : '');
    };
    tick();
    const id = setInterval(tick, 30000);
    return () => clearInterval(id);
  }, [startIso]);

  return elapsed;
}
